(function() {
  var wid = $WR.define('cheetahApplication/form/DesignerSaveAndCloseButton', [], function(require, exports, module) {
    var HTML = '';

    var Class = MW.extend(require('designer/form/default/Button'), {
      defaults: {
        xtype: 'saveAndCloseButton',
        xtypeName: '保存关闭',
        value: "保存",
        actionName: "保存关闭",
        action: "formSaveAndClose",
        sizeCls: "btn-std",
        iconCls: "fa fa-save",
        colorCls: "btn-primary"
      }
    });
    module.exports = Class;
  });
  $WR.defineType({
    id: wid,
    xtype: 'DesignerSaveAndCloseButton',
    designer: ''
  });
})();


(function() {
  var wid = $WR.define('cheetahApplication/form/saveAndCloseButton', [], function(require, exports, module) {
    var HTML = '';
    module.exports = require('form/default/Button');
  });
  $WR.defineType({
    id: wid,
    xtype: 'saveAndCloseButton',
    designer: 'DesignerSaveAndCloseButton'
  });
})();



// WEBPACK FOOTER //
// ./src/common/formWidget/saveAndCloseButton.js